if (!customElements.get('lifestyle-video')) {
  customElements.define(
    'lifestyle-video',
    class LifestyleVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.playsInline = true;

        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleMotionPreference = this.handleMotionPreference.bind(this);
        this.reducedMotionQuery.addEventListener('change', this.handleMotionPreference);
        this.handleMotionPreference();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.reducedMotionQuery?.removeEventListener('change', this.handleMotionPreference);
      }

      handleMotionPreference() {
        this.observer?.disconnect();

        if (this.reducedMotionQuery.matches) {
          this.video.pause();
          this.video.controls = true;
          return;
        }

        this.video.controls = false;
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          },
          {threshold: 0.3},
        );
        this.observer.observe(this);
      }
    },
  );
}
